<template>
  <div></div>
</template>

<script>
export default {
  props: ["value"],

  data() {
    return {
      obj: null
    };
  },

  watch: {
    value(val) {
      if (this.obj) {
        const current = this.obj.summernote("code");
        if (val !== current) {
          this.obj.summernote("code", val || "");
        }
      }
    }
  },

  mounted() {
    let vue = this;

    vue.obj = $(this.$el);

    let option = {
      height: 250,
      fontNamesIgnoreCheck: ["Verdana"],
      callbacks: {
        onChange(contents) {
          vue.$emit("input", contents);
        }
      }
    };

    // Initialize Summernote
    vue.obj.summernote(option);

    // Set default font to Verdana
    vue.obj.summernote("fontName", "Verdana");

    // Initialize with initial value
    if (this.value) {
      vue.obj.summernote("code", this.value);
    }
  },

  beforeDestroy() {
    if (this.obj) {
      this.obj.summernote("destroy");
    }
  }
};
</script>